(() => {
  const loadingClass = 'image-loading';
  const loadedClass = 'image-loaded';
  const productImageSelector = [
    'img[data-product-image]',
    '.product-card img',
    '.header-search-dropdown__product-image img',
    '.product-media img',
    '.product-media-thumbnail img',
    '.cart-item__media img'
  ].join(',');
  const productImageContainerSelector = [
    '.product-card',
    '.header-search-dropdown__product-image',
    '.product-media',
    '.product-media-thumbnail',
    '.cart-item__media'
  ].join(',');

  const isLoaded = (image) => {
    return image.complete && image.naturalWidth > 0;
  };

  const isProductImage = (image) => {
    return image.matches(productImageSelector) || Boolean(image.closest(productImageContainerSelector));
  };

  const markLoaded = (image) => {
    image.classList.remove(loadingClass);
    image.classList.add(loadedClass);
  };

  const markLoading = (image) => {
    if (image.classList.contains(loadedClass) || isLoaded(image)) {
      markLoaded(image);
      return;
    }

    image.classList.add(loadingClass);

    image.addEventListener('load', () => markLoaded(image), { once: true });
    image.addEventListener('error', () => markLoaded(image), { once: true });
  };

  const watchImages = (root = document) => {
    root.querySelectorAll(productImageSelector).forEach(markLoading);
  };

  watchImages();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches('img') && isProductImage(node)) {
          markLoading(node);
          return;
        }

        watchImages(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
